import { BoxProps, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ShoppingPurchasedThickIcon } from "../../icons/ShoppingPurchasedThickIcon";

interface YouPurchasedThisLabelProps extends BoxProps {
  compact?: boolean;
  fontSize?: string | Record<string, string> | number;
}

export function YouPurchasedThisLabel({
  compact = false,
  fontSize,
  ...props
}: YouPurchasedThisLabelProps) {
  const { t } = useTranslation();

  return (
    <Flex flexDirection="row" gap="4px" alignItems="center" {...props}>
      <ShoppingPurchasedThickIcon boxSize="16px" color="info.200" />
      <Text
        variant="releasePriceLabel"
        color="charcoal.200"
        fontSize={fontSize}
      >
        {compact
          ? t("components.cards.purchasedContentBadge.purchased")
          : t("components.cards.purchasedContentBadge.youPurchasedThis")}
      </Text>
    </Flex>
  );
}
